// extracted by mini-css-extract-plugin
export default {"texto":"styles_texto__YCd0c","input":"styles_input__LxCmB"};